import { render, staticRenderFns } from "./LocalEstoquesPage.vue?vue&type=template&id=1b40eae6&"
import script from "./LocalEstoquesPage.vue?vue&type=script&lang=js&"
export * from "./LocalEstoquesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports